(function ($) {

'use strict';

	/**
	 * Gets numeric values from the passed attribute. 
	 * If the attribute is not available use the defaultValue.
	 * @param {jQuery} $slider
	 * @param {string} attrName
	 * @param {number|bool} defaultValue
	 * @param {bool} forceBool
	 * @returns {Boolean}
	 */
	$.numParamFromAttr = function ($slider, attrName, defaultValue, forceBool) {
		var param = $slider.attr(attrName);
		if (!$.isNumeric(param)) {
			if (forceBool && typeof param === 'string') {
				if (param.toLowerCase() === 'true') {
					param = true;
				} else if (param.toLowerCase() === 'false') {
					param = false;
				} else {
					param = defaultValue;
				}
			} else {
				param = defaultValue;
			}
		} else if (forceBool) {
			param = (param !== '0');
		}
		return param;
	}; // $.numParamFromAttr

}(jQuery));